/* eslint-disable import/prefer-default-export */
import axios from 'axios';

const apiKey = process.env.REACT_APP_GOOGLE_GEOCODING_API_KEY;

export async function reverseGeo({ lat, lng }) {
  try {
    const requestUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
    const res = await axios.get(requestUrl);
    return res.data;
  } catch (error) {
    return false;
  }
}
